import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

// 🔹 تشخیص دقیق محیط توسعه لوکال
export const checkIsLocalhost = () => {
  return Boolean(
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname.includes('192.168.') ||
    process.env.NODE_ENV === 'development'
  );
};

// 🔹 تشخیص دقیق محیط تلگرام (شامل لوکال برای تست راحت)
export const checkIsInsideTelegram = () => {
  if (checkIsLocalhost()) return true;

  const tg = window.Telegram?.WebApp;
  const directChatId = tg?.initDataUnsafe?.user?.id || tg?.initDataUnsafe?.chat?.id;
  if (directChatId) return true;

  return Boolean(
    (tg && tg.platform && tg.platform !== 'unknown') ||
    (tg && tg.initData && tg.initData !== '') ||
    window.location.hash.includes('tgWebAppData') ||
    window.location.search.includes('tgWebAppPlatform')
  );
};

// 🔹 تابع متمرکز تشخیص وضعیت کاربر (بیرون آورده شد تا همه جا قابل import باشد)
export const getAuthStatus = () => {
  const token = localStorage.getItem('ACCESS_TOKEN');
  const isProfileComplete = localStorage.getItem('isProfileComplete') === 'true';
  const isTelegram = checkIsInsideTelegram();

  return {
    hasToken: Boolean(token),
    isProfileComplete,
    isTelegram
  };
};

export const useAuthPrompt = (onOpenRegister) => {
  const navigate = useNavigate();

  // تابع اصلی نمایش آلرت و هدایت هوشمند به مسیر درست (/login یا /Register)
  const triggerRegisterAlert = (options = {}) => {
    const { hasToken, isTelegram } = getAuthStatus();

    const {
      onBeforeOpen,
      delay = 0,
      forceLogin = false // در صورتی که مثلاً خطای 401 از سمت سرور آمد
    } = options;

    // اگر خارج از تلگرام است و توکن ندارد (یا توکن منقضی شده)، باید به فرم لاگین موبایل برود
    const shouldGoToLogin = !isTelegram && (!hasToken || forceLogin);

    // تنظیم داینامیک متن‌ها بر اساس وضعیت کاربر
    const title = options.title || (
      shouldGoToLogin
        ? 'ورود به حساب کاربری'
        : (hasToken ? 'تکمیل اطلاعات کاربری' : 'نیاز به عضویت')
    );

    const message = options.message || (
      shouldGoToLogin
        ? 'لطفاً برای ادامه، ابتدا با شماره موبایل خود وارد شوید.'
        : (hasToken
            ? 'لطفاً برای ادامه فرآیند، اطلاعات پروفایل (نام و نام خانوادگی) خود را تکمیل نمایید.'
            : 'لطفاً برای ادامه فرآیند ثبت نام خود را تکمیل نمایید.')
    );

    const confirmText = options.confirmText || (
      shouldGoToLogin
        ? 'ورود با شماره موبایل'
        : (hasToken ? 'تکمیل پروفایل' : 'ثبت‌ نام / ورود')
    );

    if (typeof onBeforeOpen === 'function') {
      onBeforeOpen();
    }

    setTimeout(() => {
      Swal.fire({
        icon: 'warning',
        title: title,
        html: `<div style="font-size: 0.95rem; line-height: 1.8; color: #444;">${message}</div>`,
        showCancelButton: true,
        confirmButtonText: confirmText,
        cancelButtonText: 'انصراف',
        buttonsStyling: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: {
          container: 'swal-custom-container',
          popup: 'swal-custom-popup',
          title: 'swal-custom-title',
          htmlContainer: 'swal-custom-text',
          actions: 'swal-custom-actions',
          confirmButton: 'swal-confirm-custom-btn',
          cancelButton: 'swal-cancel-custom-btn'
        },
        didOpen: () => {
          const swalContainer = document.querySelector('.swal2-container');
          if (swalContainer) {
            swalContainer.style.zIndex = '999999';
          }
        }
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.close();
          setTimeout(() => {
            if (shouldGoToLogin) {
              // حالت ۱ (خارج از تلگرام و بدون JWT): هدایت به فرم لاگین موبایل
              navigate('/login');
            } else {
              // حالت ۲ و ۳ (داخل تلگرام یا دارای توکن ولی پروفایل ناقص): هدایت به فرم ثبت‌نام / تکمیل اطلاعات
              if (typeof onOpenRegister === 'function') {
                onOpenRegister();
              } else {
                window.dispatchEvent(new CustomEvent('OPEN_REGISTER_MODAL'));
                navigate('/Register');
              }
            }
          }, 100);
        }
      });
    }, delay);
  };

  // گارد کلیک‌ها (مانند دکمه گزارشات در فوتر یا خرید)
  const checkAuthAndRun = (callback, options = {}) => {
    const { hasToken, isProfileComplete, isTelegram } = getAuthStatus();

    // ۱. خارج از تلگرام است و توکن JWT ندارد -> هدایت به /login
    if (!isTelegram && !hasToken) {
      triggerRegisterAlert(options);
      return false;
    }

    // ۲. پروفایل کامل نیست (یا در تلگرام هنوز ثبت‌نام نکرده، یا در وب لاگین کرده ولی نام و نام خانوادگی ندارد) -> هدایت به /Register
    if (!isProfileComplete) {
      triggerRegisterAlert(options);
      return false;
    }

    // ۳. همه چیز کامل است -> اجرای عملیات
    if (typeof callback === 'function') {
      callback();
    }
    return true;
  };

  return {
    triggerRegisterAlert,
    checkAuthAndRun,
    getAuthStatus
  };
};

export default useAuthPrompt;
